var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex cursor-pointer gap-2",class:{ 'w-full': _vm.label },on:{"click":_vm.toggle}},[_c('span',{class:_vm.tickClass},[(_vm.value)?_c('tick-icon'):_vm._e()],1),(_vm.label)?_c('span',{class:`${_vm.labelClass || 'text-white'}`},[_vm._v(_vm._s(_vm.label))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }